import React from 'react'
import { FOODSBY_ADDRESS } from '../../util/constants'

const TermsOfUse = () => (
  <div>
    <section>
      <div className="row center-xs">
        <div className="col-xs-12 center-xs">
          <h1 className="title">Terms of Use</h1>
        </div>
      </div>
    </section>

    <section>
      <div className="row">
        <div className="col-xs-12 start-xs">
          <p>
            <strong>TERMS OF USE</strong>
          </p>
          <p>
            Thank you for visiting this website, which is owned and operated by Foodsby, Inc.
            (“Foodsby,” “we,” “us” and “our”). These Terms of Use govern your use of the publicly
            available portions of this website (this “Site”). The password-protected portions of
            this website are intended to be used only by our clients and are governed by separate
            contractual agreements.
          </p>
          <br />
          <p>
            PLEASE READ THE TERMS OF USE BELOW. THESE TERMS OF USE, INCLUDING ANY REVISED AGREEMENTS
            THAT WE MAY POST FROM TIME TO TIME, STATE THE TERMS AND CONDITIONS UNDER WHICH FOODSBY
            PROVIDES YOU WITH VARIOUS SERVICES ON THE FOLLOWING THE SITE. ALL SERVICES PROVIDED BY
            FOODSBY ON THE SITE ARE COLLECTIVELY REFERRED TO AS “FOODSBY SERVICES.” BY ACCESSING,
            BROWSING AND/OR USING OUR WEB SITE AND/OR SERVICES POSTED ON THE WEB SITE, YOU ARE
            DEEMED TO ACCEPT THE TERMS OF USE AND AGREE TO BE BOUND BY THIS AGREEMENT WITH RESPECT
            TO THE USE OF THAT WEB SITE. IF YOU DO NOT WISH TO BE BOUND BY THIS AGREEMENT, PLEASE DO
            NOT ACCESS, BROWSE OR USE OUR WEB SITE OR ANY SERVICES WE PROVIDE.
          </p>
          <p>
            <strong>Ownership and Protection of Intellectual Property Rights</strong>
          </p>
          <p>
            The contents of our Site are intended for the personal, noncommercial use of our users.
            All right, title and interest to the content displayed on our Site, including but not
            limited to the Site’s look and feel, data, information, text, graphics, images, sound or
            video materials, photographs, designs, trademarks, service marks, trade names, URLs and
            content provided by third parties, are the property of Foodsby, or the respective third
            parties, and are protected by copyright, trademark, patent or other proprietary rights
            and laws.
          </p>
          <p>
            Except as expressly authorized by Foodsby, you agree not to copy, modify, rent, lease,
            loan, sell, assign, distribute, perform, display, license, reverse engineer or create
            derivative works based on the Site or any Content (including without limitation any
            software) available through the Site.
          </p>
          <p>
            <strong>Changes to This Agreement</strong>
          </p>
          <p>
            Foodsby may make changes to this Agreement from time to time in its sole discretion.
            Each time changes are made to this Agreement, a revised Agreement will be posted on the
            home page. Your continued use of our Site following the posting of changes constitutes
            your acceptance of any such changes. You can review the most current version of this
            Agreement here. Please check this page from time to time for current terms of use.
          </p>
          <p>
            <strong>Your Acceptance of Our Privacy Policy</strong>
          </p>
          <br />
          <p>
            By agreeing to these Terms of Use, you agree to the terms of our Privacy Policy&nbsp;
            <a href="https://www.foodsby.com/main/privacy-policy/">
              https://www.foodsby.com/main/privacy-policy/
            </a>
          </p>
          <p>
            which is expressly incorporated herein. Before using this Site, please carefully review
            our Privacy Policy. All information provided to us as a result of your use of this Site
            will be handled in accordance with our Privacy Policy. To the extent there are
            inconsistencies between these Terms of Use and our Privacy Policy, these Terms of Use
            control.
          </p>
          <p>
            <strong>Other Policies</strong>
          </p>
          <p>
            Your use of our Site is also subject to the other policies, disclaimers and guidelines
            we post on such Site from time to time.
          </p>
          <p>
            <strong>License Grant to Access Content on Our Site</strong>
          </p>
          <p>
            You are hereby granted a personal, nonexclusive, nontransferable, revocable, limited
            license to view, reproduce, print, cache, store and distribute content retrieved from
            our Site via a generally available consumer web browser, provided that you do not (and
            do not allow any third party to) copy, modify, create a derivative work of, reverse
            engineer, reverse assemble or otherwise attempt to discover any source code, sell,
            assign, sublicense, grant a security interest in or otherwise transfer any right in the
            Foodsby Services or remove or obscure the copyright notice or other notices displayed on
            the content. You may not reproduce, print, cache, store or distribute content retrieved
            from the Site in any way, for any commercial use without the prior written permission of
            Foodsby or the copyright holder identified in the relevant copyright notice.
          </p>
          <p>
            Except as expressly provided in this Agreement, nothing contained in this Agreement or
            on the Site shall be construed as conferring any other license or right, expressly, by
            implication, by estoppel or otherwise, with respect to any of Foodsby’s content or under
            any third party’s content. Any rights not expressly granted herein are reserved.
          </p>
          <p>
            If you choose to forward content from the Site via email through our Services, you agree
            that you will only forward such content to willing recipients known to you and that you
            will not use such Services for engaging in spam or other unauthorized conduct.
          </p>
          <p>
            <strong>Your Obligations</strong>
          </p>
          <p>
            In consideration of your use of this Site, you agree that to the extent you provide
            personal information to Foodsby it will be true, accurate, current, and complete and
            that you will update all personal information as necessary.
          </p>
          <br />
          <p>
            To the extent you create an account through this Site, you understand and agree that any
            account you create, including your username and password, are personal to you and may
            not be used by anyone else. You are responsible for maintaining the confidentiality of
            your username and password and are fully responsible for all activities that occur under
            your username and password by you or by anyone else using your username and password,
            whether or not authorized by you. You agree to change your password immediately if you
            believe your password may have been compromised or used without authorization. You also
            agree to immediately inform us of any apparent breaches of security such as loss, theft
            or unauthorized disclosure or use of your username or password by contacting us using
            the information provided below. Until we are so notified you will remain liable for any
            unauthorized use of your account.
          </p>
          <br />
          <p>
            You agree to use this Site in a manner consistent with any and all applicable rules and
            regulations. You agree not to upload or transmit through this Site any computer viruses,
            trojan horses, worms or anything else designed to interfere with, interrupt or disrupt
            the normal operating procedures of a computer. Any unauthorized modification, tampering
            or change of any information, or any interference with the availability of or access to
            this Site is strictly prohibited. We reserve all rights and remedies available to us.
          </p>
          <p>
            <strong>No Automated Querying</strong>
          </p>
          <p>
            You may not send automated queries of any sort to our site without express advance
            written permission from Foodsby. Note that “sending automated queries” includes, among
            other things:
          </p>
          <ul>
            <li>
              using any software which sends queries to our sites to determine how a website or
              webpage “ranks” for various queries;
            </li>
            <li>“meta-searching”; and</li>
            <li>performing “offline” searches on the Foodsby web site</li>
          </ul>
          <p>
            <strong>
              Responsibility for User-Generated Content Posted on or Through this Site
            </strong>
          </p>
          <br />
          <p>
            In these Terms of Use, the terms “User-Generated Content” and “UGC” refer to all of the
            text, photographs, images, illustrations, graphics, sounds, video and audio-video clips,
            and other Content you post using the social networking tools we make available to you
            and that does not constitute “Feedback,” which is defined below.
          </p>
          <br />
          <p>
            <em>You are responsible for User-Generated Content that you post.</em>
          </p>
          <br />
          <p>
            Under no circumstances will we be liable in any way for any UGC. This means that you,
            not Foodsby, are entirely responsible for all UGC that you post and that you can be held
            personally liable for comments that are defamatory, obscene, or libelous, or that
            violate these Terms of Use, an obligation of confidentiality, or the rights of others.
            If any part of the UGC you post is not your original work, it is your responsibility to
            obtain any necessary permission to post it.
          </p>
          <br />
          <p>
            Because we do not control the UGC posted on or through this Site, we cannot and do not
            warrant or guarantee the truthfulness, integrity, suitability, or quality of that UGC.
            You also agree and understand that by accessing this Site, you may encounter UGC that
            you may consider to be objectionable. We have no responsibility for any UGC, including
            without limitation any errors or omissions therein. We are not liable for any loss or
            damage of any kind you may claim was incurred as a result of the use of any UGC posted,
            emailed, transmitted or otherwise made available on or through this Site. The UGC posted
            on or through this Site expresses the personal opinions of the individuals who posted it
            and does not necessarily reflect the views of Foodsby or any person or entity associated
            with Foodsby.
          </p>
          <br />
          <p>
            <em>You own User-Generated Content, but we may use it. </em>
          </p>
          <br />
          <p>
            You own the copyright in any original UGC you post. We do not claim any copyrights in
            UGC. However, by using this Site you are granting us and our subsidiaries, affiliates,
            successors and assigns, a nonexclusive, fully paid, worldwide, perpetual, irrevocable,
            royalty-free, transferable license (with the right to sublicense through unlimited
            levels of sublicensees) to use, copy, modify, distribute, publicly display and perform,
            publish, transmit, remove, retain repurpose, and commercialize UGC you post in any and
            all media or form of communication whether now existing or hereafter developed, without
            obtaining additional consent, without restriction, notification, or attribution, and
            without compensating you in any way, and to authorize others to do the same. For this
            reason, we ask that you not post any UGC that you do not wish to license to us,
            including any photographs, videos, confidential information, or product ideas.
          </p>
          <br />
          <p>
            <em>We may disclose and/or remove User-Generated Content. </em>
          </p>
          <br />
          <p>
            Foodsby has certain rights. We have the right (but do not assume the obligation) to:
          </p>
          <br />
          <ul>
            <li>monitor all UGC;</li>
            <li>require that you avoid certain subjects;</li>
            <li>
              remove or block any UGC at any time without notice at our sole and absolute
              discretion;
            </li>
            <li>
              disclose any UGC and the identity of the user who posted it in response to a subpoena
              or whenever we believe that disclosure is appropriate to comply with the law or a
              court order, to prevent or investigate a possible crime or other violation of law, to
              protect the rights of Foodsby or others, or to enforce these Terms of Use; and
            </li>
            <li>
              terminate your access to and use of this Site, or to modify, edit or block your
              transmissions thereto in our sole discretion.
            </li>
          </ul>
          <br />
          <p>
            You agree that our exercise of such discretion shall not render us the owners of UGC you
            post, and that you will retain ownership thereof as described above.
          </p>
          <br />
          <p>
            <em>Restrictions on User-Generated Content.</em>
          </p>
          <br />
          <p>It is a condition of these Terms of Use that you do not:</p>
          <br />
          <ul>
            <li>
              upload, post, transmit or otherwise make available:
              <ul>
                <li>
                  any UGC that is unlawful, harmful, hateful, threatening, abusive, harassing,
                  libelous, defamatory, obscene, vulgar, pornographic, profane, racially
                  disparaging, indecent, or invasive of another’s privacy;
                </li>
                <li>
                  any UGC that constitutes or encourages activity illegal under criminal or civil
                  law;
                </li>
                <li>any UGC that is false, misleading, or fraudulent;</li>
                <li>
                  any UGC that you do not have a right to make available under any law or under
                  contractual or fiduciary relationships (such as inside information or proprietary
                  and confidential information learned or disclosed as part of employment
                  relationships or under nondisclosure agreements);
                </li>
                <li>
                  any UGC that violates or infringes upon the rights of others, including UGC which
                  violates the patent rights, copyrights, trademark rights, privacy rights,
                  publicity rights, trade secret rights, confidentiality rights, contract rights, or
                  any other rights of any individual, living or deceased, or any legal entity;
                </li>
                <li>
                  any UGC that contains the image, name or likeness of anyone other than yourself,
                  unless (i) that person is at least eighteen years old and you have first obtained
                  his/her express permission or (ii) that person is under eighteen years old but you
                  are his/her parent or legal guardian;
                </li>
                <li>
                  any request for or solicitation of any personal or private information from any
                  individual;
                </li>
                <li>
                  any request for or solicitation of money, goods, or services for private gain;
                </li>
                <li>
                  any material that contains software viruses or any other computer code, files or
                  programs designed to interrupt, destroy or limit the functionality of any computer
                  software or hardware or telecommunications equipment; or
                </li>
                <li>
                  any UGC that contains advertising, promotions or marketing, or which otherwise has
                  a commercial purpose;
                </li>
              </ul>
            </li>
            <li>
              impersonate any person or entity or falsely state or otherwise misrepresent your
              affiliation with a person or entity; or
            </li>
            <li>violate any local, state, national or international law, rule or regulation.</li>
          </ul>
          <br />
          <p>
            By posting User-Generated Content, you represent and warrant that (i) you own or
            otherwise control all of the rights to the UGC and have the right to grant the license
            set forth in these Terms of Use; (ii) the UGC is accurate, and (iii) you have read and
            understood—and your UGC fully complies with—these Terms of Use and applicable laws and
            will not cause injury to any person or entity.
          </p>
          <br />
          <p>
            <strong>Removal of Content</strong>
          </p>
          <br />
          <p>
            <em>In general.</em>
          </p>
          <br />
          <p>
            You can seek removal of objectionable UGC by contacting us using the information
            provided below. We will review all such requests and will remove UGC that we determine
            should be removed, in our sole discretion and in accordance with these Terms of Use and
            applicable law. Please be aware, however, that if the UGC has already been distributed
            to other websites or published in other media, we will not be able to recapture and
            delete it. Also, a back-up or residual copy of the UGC we remove from this Site may
            remain on back-up servers.
          </p>
          <br />
          <p>
            <em>Violation of copyrights.</em>
          </p>
          <br />
          <p>
            Foodsby does not knowingly violate or permit others to violate the copyrights of others.
            We will promptly remove or disable access to material that we know is infringing or if
            we become aware of circumstances from which infringing activity is apparent.
          </p>
          <br />
          <p>
            If you are requesting removal of content because of a violation of your copyrights,
            please note that the Digital Millennium Copyright Act of 1998 (the “DMCA”) provides
            recourse for copyright owners who believe that material appearing on the Internet
            infringes their rights under U.S. copyright law. If you believe that your own work, or
            the work of a third party for whom you are authorized to act, is featured on this Site
            or has been otherwise copied and made available on this Site in a manner that constitute
            copyright infringement, please notify us immediately. Your notice must be in writing and
            must include
          </p>
          <br />
          <ul>
            <li>
              an electronic or physical signature of the copyright owner or of the person authorized
              to act on behalf of the owner of the copyright interest;
            </li>
            <li>a description of the copyrighted work that you claim has been infringed;</li>
            <li>
              a description of where the material that you claim is infringing is located on this
              Site (including the URL, title and/or item number if applicable, or other identifying
              characteristics);
            </li>
            <li>
              your name, address, telephone number, and email address, and, if you are not the owner
              of the copyright, the name of the owner; and
            </li>
            <li>
              a written statement by you that you have a good-faith belief that the disputed use is
              not authorized by the copyright owner, its agent, or the law; and
            </li>
            <li>
              a statement by you, made under penalty of perjury, that the above information in your
              notice is accurate and that you are the copyright owner or authorized to act on the
              copyright owner’s behalf.
            </li>
          </ul>
          <br />
          <p>Your statement must be addressed as follows:</p>
          <br />

          <div>
            <p>
              Foodsby
              <br />
              {FOODSBY_ADDRESS.STREET}
              <br />
              {FOODSBY_ADDRESS.CITY}, {FOODSBY_ADDRESS.STATE} {FOODSBY_ADDRESS.ZIP}
            </p>
          </div>
          <p>
            Any notification by a copyright owner or a person authorized to act on its behalf that
            fails to comply with requirements of the DMCA shall not be considered sufficient notice
            and shall not be deemed to confer upon us actual knowledge of facts or circumstances
            from which infringing material or acts are evident.
          </p>
          <br />
          <p>
            <strong>Your Feedback </strong>
          </p>
          <br />
          <p>
            In these Terms of Use, the term “Feedback” refers to the Content you post on or through
            this Site that is specifically about how we can improve this Site and the products and
            services we make available through this Site.
          </p>
          <br />
          <p>
            Although we do not claim ownership of User-Generated Content you post using this Site,
            the Feedback you provide to us through this Site will be and remain our exclusive
            property. Your submission of Feedback will constitute an assignment to us of all
            worldwide rights, title and interests in your Feedback, including all copyrights and
            other intellectual property rights in your Feedback. We will be entitled to reduce to
            practice, exploit, make, use, copy, disclose, display or perform publicly, distribute,
            improve and modify any Feedback you submit for any purpose whatsoever, without
            restriction and without compensating you in any way. For this reason, we ask that you
            not send us any Feedback that you do not wish to assign to us.
          </p>
          <p>
            <strong>Passwords and Security</strong>
          </p>
          <p>
            Access to certain Foodsby Services may require you to choose a user name (or nickname)
            and password. If you do so, you are responsible for maintaining the confidentiality of
            your password and account and for logging out of your account at the end of each
            session. In selecting a user name, you agree that you will not (i) select or use a
            screen name of another person with the intent to impersonate that person; (ii) use a
            name subject to the rights of any person without their authorization; or (iii) use a
            screen name that is offensive to people of ordinary sensitivities, illegal, or
            infringing. You are fully responsible for all activities that occur under your password
            or account. You agree (a) to notify Foodsby immediately of any unauthorized use of your
            password or account or any other breach of security, and (b) to ensure that you exit
            from your account at the end of each session. Foodsby cannot and will not be liable for
            any loss or damage arising from your failure to comply with this section.
          </p>
          <p>
            <strong>Links to Other Web Sites</strong>
          </p>
          <p>
            A central part of the Foodsby Services includes links to other World Wide Web sites or
            resources, including our third-party nightclub sponsors. Because Foodsby has no control
            over such sites and resources, you acknowledge and agree that Foodsby is not responsible
            for the availability of such external sites or resources, and does not endorse and is
            not responsible or liable for any content, advertising, products, or other materials on
            or available from such sites or resources. You further acknowledge and agree that
            Foodsby shall not be responsible or liable, directly or indirectly, for any damage or
            loss caused by or in connection with use of or reliance on any such content, goods or
            services available on or through any such site or resource. Finally, you acknowledge
            that such external sites usually have their own terms and conditions, including privacy
            policies, over which Foodsby has no control and which will govern your rights and
            obligations with respect to the use of those Web sites.
          </p>
          <p>
            <strong>Your Contact with Advertisers or Third-Party Vendors</strong>
          </p>
          <p>
            Your dealings with advertisers and third-party vendors found on or through the Foodsby
            Services, including your participation in promotions, the purchase of goods, and any
            terms, conditions, warranties or representations associated with such activities, are
            solely between you and the third party. Foodsby does not make any representations or
            warranties with respect to any goods or web sites that may be obtained from such third
            parties, and you agree that Foodsby will have no liability for any loss or damage of any
            kind incurred as a result of any activities you undertake in connection with the use of
            or reliance on any content, goods, services, information or other materials available,
            or through such third parties, on our Site. You acknowledge that such external sites
            usually have their own terms and conditions, including privacy policies, over which
            Foodsby has no control and which will govern your rights and obligations with respect to
            the use of those Web sites.
          </p>
          <p>
            <strong>Compliance with Laws</strong>
          </p>
          <p>
            You agree to comply with all applicable laws regarding your use of our Site including,
            without limitation, all applicable laws (as well as associated licenses and approvals)
            regarding the transmission of technical data exported from the United States or the
            country in which you reside.
          </p>
          <p>
            <strong>Modifications to Foodsby Services</strong>
          </p>
          <p>
            Foodsby reserves the right at any time and from time to time to modify, suspend,
            discontinue or terminate the Foodsby Services (or any part thereof) with or without
            notice. You agree that Foodsby will not be liable to you or to any third party for any
            modification, suspension, discontinuation or termination of the Foodsby Services.
          </p>
          <p>
            <strong>Termination of Your Access to Foodsby Services</strong>
          </p>
          <p>
            You agree that Foodsby, in its sole discretion, may terminate your access to any of the
            Foodsby Services, and/or remove, discard or modify any User Generated Content or content
            within the Service, for any reason, including, without limitation, for lack of use or if
            Foodsby believes that you have violated or acted inconsistently with the letter or
            spirit of this Agreement. You agree that any termination of your access to the Foodsby
            Services may be affected without prior notice, and acknowledge and agree that Foodsby
            may immediately deactivate or delete your account and all related information and files
            in your account and/or bar any further access to such files or the Foodsby Services. If
            you use the Site in violation of this Agreement, Foodsby may, in its sole discretion,
            retain all data collected from your use of the Site. Further, you agree that Foodsby
            shall not be liable to you or any third party for the discontinuation or termination of
            your access to the Foodsby Services, or collection of information notwithstanding in the
            case of your violation of this Agreement, even if advised of a claim for damages.
          </p>
          <p>
            <strong>Information Disclaimer and Disclaimer of Warranties</strong>
          </p>
          <p>BY USING FOODSBY SERVICES YOU UNDERSTAND AND AGREE THAT:</p>
          <ol>
            <li>
              Foodsby does not prepare, LABEL, sell, store, TRANSPORT, DELIVER or distribute food or
              beverages, but merely provides a convenient ordering system for you to obtain food
              and/ or beverages from third party vendors. Foodsby is not responsible for the safety
              or quality of the food or beverages, OR FOR THEIR INGREDIENTS, LABELING OR PACKAGING,
              prepared AND/or delivered by third party vendors or for any activities that are the
              direct or indirect consequences of third party vendors’ food preparation, labeling,
              transport or delivery.
            </li>
            <li>
              NO CONTENT ON OUR SITE IS INTENDED TO CONSTITUTE PROFESSIONAL ADVICE, WHETHER MEDICAL,
              HEALTH, SAFETY-RELATED, FINANCIAL, LEGAL OR OTHERWISE. FOODSBY AND THOSE POSTING OR
              OTHERWISE PROVIDING INFORMATION, SERVICES OR MATERIAL ON OUR SITE ARE NOT RESPONSIBLE
              OR LIABLE FOR ANY CONSEQUENCES RELATING DIRECTLY OR INDIRECTLY TO ANY ACTION OR
              INACTION YOU TAKE BASED ON THE INFORMATION, SERVICES OR OTHER MATERIAL ON OUR SITE.
            </li>
            <li>
              YOUR USE OF THE FOODSBY SERVICES IS AT YOUR SOLE RISK. THE FOODSBY SERVICES, AND FOODS
              PROVIDED BY THIRD PARTY VENDORS, ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS.
              FOODSBY EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED,
              INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF TITLE, MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NON- INFRINGEMENT.
            </li>
            <li>
              YOU ARE SOLELY RESPONSIBLE FOR, AND ASSUME ALL RISKS RELATED TO, THE ORDERING, PROPER
              HANDLING, USE AND CONSUMPTION OF THE FOOD YOU RECEIVE FROM THIRD PARTIES. YOU ARE ALSO
              SOLELY RESPONSIBLE FOR KNOWING ABOUT ANY FOOD ALLERGIES YOU MAY HAVE AND VERIFYING THE
              PRODUCTS AND THEIR CONTENTS BEFORE HANDLING, USING OR CONSUMING SUCH FOOD. IF YOU HAVE
              FOOD ALLERGIES OR INGREDIENT QUESTIONS OR CONCERNS, PLEASE DIRECT THOS QUESTIONS TO
              THE VENDOR.
            </li>
            <li>
              FOODSBY MAKES NO REPRESENTATION OR WARRANTY THAT FOODSBY SERVICES WILL MEET YOUR
              REQUIREMENTS, THAT THE FOODSBY SERVICES WILL BE UNINTERRUPTED, SECURE, CURRENT OR
              ERROR-FREE, THAT THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE FOODSBY SERVICE
              WILL BE ACCURATE, TIMELY, USEFUL OR RELIABLE, OR THAT THE QUALITY OF ANY FOOD,
              BEVERAGES, POSTINGS, PRODUCTS, SERVICES, INFORMATION OR OTHER MATERIAL OBTAINED BY YOU
              THROUGH FOODSBY SERVICES WILL MEET YOUR NEEDS.
            </li>
            <li>
              ANY MATERIAL OBTAINED THROUGH THE USE OF FOODSBY SERVICES IS DONE AT YOUR OWN
              DISCRETION AND RISK, AND YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO COMPUTER
              SYSTEMS OR FOR LOSS OF DATA THAT RESULTS FROM THE DOWNLOAD OR USE OF ANY SUCH
              MATERIAL.
            </li>
            <li>
              NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM OUR SITE OR
              THROUGH OR FROM THE FOODSBY SERVICES SHALL CREATE ANY WARRANTY NOT EXPRESSLY STATED IN
              THEIR TERMS.
            </li>
          </ol>
          <p>
            <strong>Limitation of Liability</strong>
          </p>
          <p>
            YOU UNDERSTAND AND AGREE THAT FOODSBY IS NOT LIABLE FOR ANY INDIRECT, INCIDENTAL,
            SPECIAL, CONSEQUENTIAL, EXEMPLARY OR PUNITIVE DAMAGES, INCLUDING, BUT NOT LIMITED TO,
            ANY LOSS OF USE, LOSS OF PROFITS, LOSS OF DATA, LOSS OF GOODWILL, COST OF PROCUREMENT OF
            SUBSTITUTE SERVICES, OR ANY OTHER INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL,
            EXEMPLARY OR PUNITIVE DAMAGES, HOWSOEVER CAUSED, AND ON ANY THEORY OF LIABILITY, WHETHER
            FOR BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE AND STRICT LIABILITY), OR OTHERWISE
            RESULTING FROM: (1) THE USE OF, OR THE INABILITY TO USE, FOODSBY SERVICES, (2) THE COST
            OF PROCUREMENT OF SUBSTITUTE SERVICES, GOODS OR AND WEB SITE, (3) UNAUTHORIZED ACCESS TO
            OR ALTERATION OF YOUR TRANSMISSIONS OR DATA, (4) THE STATEMENTS OR CONDUCT OF ANY THIRD
            PARTY ON OUR SITE, (5) RELIANCE ON CONTENT OR POSTINGS ON OUR SITE, OR (6) ANY OTHER
            MATTER RELATING TO OUR SITE OR FOODSBY SERVICES, INCLUDING ORDERING FOODS SERVICE FROM
            THIRD PARTIES THROUGH THE SITE OR ANY CLAIMS OF ILLNESS OR INJURY RESULTING FROM FOOD
            PURCHASED THROUGH THE SITE. THESE LIMITATIONS WILL APPLY WHETHER OR NOT FOODSBY HAS BEEN
            ADVISED OF THE POSSIBILITY OF SUCH DAMAGES AND NOTWITHSTANDING ANY FAILURE OF ESSENTIAL
            PURPOSE OF ANY LIMITED REMEDY. EXCEPT AS REQUIRED BY THE INDEMNITY PROVISIONS HEREIN, IN
            NO EVENT WILL FOODSBY’S DIRECT LIABILITY HEREUNDER EXCEED $100.00.
          </p>
          <p>
            SOME JURISDICTIONS DO NOT ALLOW THE LIMITATION OR EXCLUSION OF LIABILITY FOR INDIRECT,
            INCIDENTAL, SPECIAL, CONSEQUENTIAL, EXEMPLARY OR PUNITIVE DAMAGES, SO SOME OF THE ABOVE
            LIMITATIONS MAY NOT APPLY TO YOU.
          </p>
          <p>
            <strong>Indemnification of Foodsby</strong>
          </p>
          <p>
            To the fullest extent permitted by applicable law, you agree to indemnify, defend and
            hold harmless Foodsby, its subsidiaries, and affiliates, and their respective past,
            present, and future officers, directors, employees and agents from and against any and
            all actual and alleged liability, losses, claims, demands, disputes, damages, awards,
            judgments, obligations, penalties, interest, fees, expenses, or costs of any kind,
            whether known or unknown, including, without limitation, reasonable attorneys’ fees and
            costs of litigation, resulting from or in any way connected with (a) postings or other
            content you submit or that are submitted from your account, (b) your use of or reliance
            on Foodsby Services, (c) your connection to our Site, (d) your violation of this
            Agreement, or (e) your violation of any rights of another party, including any of our
            third party partners from whom you order food service. Foodsby shall have no liability
            to the extent that any suit or claim arises from or was caused by the negligence or
            willful misconduct of any of any third-party vendor, a defective food product prepared,
            labeled, transported or delivered by third party vendor, or the third-party vendor’s
            violation of local, state or federal laws or regulations.
          </p>
          <p>
            <strong>Trademark Notices</strong>
          </p>
          <p>
            The FOODSBY mark and the Foodsby logo are trademarks of Foodsby, Inc. All rights
            reserved. All other trademarks and logos on this site are the property of their
            respective owners.
          </p>
          <p>
            <strong>Images</strong>
          </p>
          <p>
            The images referenced, made accessible or made available to you on the Site or by means
            of the Foodsby Services are protected by the copyright and trademark laws of the United
            States and other countries. Although you are permitted to locate and access the images
            through Foodsby Services, you may need to obtain authorization of the owner of such
            materials before using them for any purpose other than viewing on the web. For
            authorizations to use an image, please contact the image owner as indicated on the
            source site, not Foodsby. Foodsby cannot give you authorization to use the copyrighted
            images. Foodsby cannot guarantee that a search will not locate unintended or
            objectionable content and Foodsby accepts no responsibility or liability for the content
            of any site included in any search results or otherwise linked to by the Ask services,
            or for your use of such content.
          </p>
          <p>
            <strong>Currency Conversions &amp; Exchange Rates</strong>
          </p>
          <p>
            Data and information is provided for informational purposes only, and is not intended
            for trading or other business purposes. Data provided may be delayed as specified by
            financial exchanges or our data providers. Foodsby does not guarantee the accuracy,
            timeliness, reliability or completeness of any currency conversion or other financial
            data. Neither Foodsby nor any of its data or content providers shall be liable for any
            errors or delays in the content, or for any actions taken in reliance thereon. You agree
            not to redistribute the data found herein.
          </p>
          <p>
            <strong>Food and Beverages</strong>
          </p>
          <p>
            Foodsby does not prepare, label, sell, store, transport, deliver or distribute food or
            beverage, but merely provides a convenient ordering service for its users to obtain food
            and/or beverage from third party establishments. Foodsby is not responsible for the
            preparation, quality or safety of food or beverages ordered through the Site, or for
            their ingredients, labeling or packaging, or for any activities that are the direct or
            indirect consequences of ordering food or beverages through this service You
            specifically release Foodsby for all liability related to these activities and assume
            all risk in placing an order form a third-party food provider.
          </p>
          <br />
          <p>
            <strong>Delivery and Pickup</strong>
          </p>
          <p>
            Foodsby and the third-party food providers will provide conditions for time and place of
            food pick-up that you must comply with as a condition of use of the Site and Foodsby
            Services. Delivered food may be left unattended in a designated delivery area in your
            building. You are responsible for complying with pickup instructions, including picking
            up food within stated timeframes within your order instructions. You must pick up your
            order promptly after delivery and consume promptly or refrigerate. Neither Foodsby or
            the food provider is responsible for missing orders, orders not promptly picked up,
            orders which have been tampered with or other issues related to the use of an unattended
            delivery area for your order. You assume the sole risk of ordering, picking up and
            consuming food and beverages ordered through the Site. Foodsby and food providers will
            specifically not be liable for food quality, or removal or purchased food if you do not
            comply with pickup time and location requirements.
          </p>
          <br />
          <p>
            <strong>No Other Agreements Between Us</strong>
          </p>
          <p>
            With the exception of our Privacy Policy, this Agreement constitutes the entire
            agreement between you and Foodsby for governing your use of our Site and Services and
            supersedes any prior agreements between you and Foodsby for that purpose, including any
            membership agreements or other similar agreements applying to our Site or Foodsby
            Services.
          </p>
          <p>
            <strong>Law Applicable to Interpretations and Disputes</strong>
          </p>
          <p>
            This Agreement and the relationship between you and Foodsby are governed by the laws of
            the State of Minnesota without regard to its conflict of law provisions. You and Foodsby
            agree to submit to the personal and exclusive jurisdiction of the Ramsey County MN
            courts.
          </p>
          <p>
            <strong>Severability of This Agreement</strong>
          </p>
          <p>
            If any provision of this Agreement is found by a court or other binding authority to be
            invalid, you agree that every attempt shall be made to give effect to the parties’
            intentions as reflected in that provision, and the remaining provisions contained in
            this Agreement shall continue in full force and effect.
          </p>
          <p>
            <strong>Limitation of Actions Brought Against Foodsby</strong>
          </p>
          <p>
            You agree that any claim or cause of action arising out of your use of our Site or this
            Agreement must be filed within one year after such claim or cause of action arose or it
            shall forever be barred, notwithstanding any statute of limitations or other law to the
            contrary. Within this period, any failure by Foodsby to enforce or exercise any
            provision of this Agreement or related right shall not constitute a waiver of that right
            or provision.
          </p>
          <p>
            If you have any questions or concerns with respect to this Agreement or our Site, you
            may contact a representative of Foodsby at info@foodsby.com or by mail at:
          </p>
          <p>
            {FOODSBY_ADDRESS.STREET}
            <br />
            {FOODSBY_ADDRESS.CITY}, {FOODSBY_ADDRESS.STATE} {FOODSBY_ADDRESS.ZIP}
          </p>
        </div>
      </div>
    </section>
  </div>
)

export default TermsOfUse
